import {mapActions, mapGetters, mapMutations} from "vuex";
import {ProjectDetails} from "@/wl-core/api/classes/ProjectDetails";

export default {
    data: () => ({
        branchDetails: null
    }),
    props: {
        project: ProjectDetails
    },

    computed: {
        ...mapGetters('project', [
            "projectDetails",
            "projectEvents",
            "projectId",
        ]),
        ...mapGetters([
            'userDetails',
            'branch',
            'isMobile',
            'loading',
        ])
    },
    methods: {
        getProject(resetProject) {
            if(resetProject) this.resetProject();
            if (this.$route.params.projectId) {
                this.setProjectId(this.$route.params.projectId)
            }
            if (this.project) {
                this.setProjectId(this.project.Project_ID)
                this.setProjectDetails(this.project)
            } else {
                this.getProjectDetails(resetProject)

            }
        },
        ...mapMutations('project', [
            "setProjectId",
            "setProjectDetails",
            "resetProject",
        ]),
        ...mapActions('project', [
            "getProjectDetails",
            "getProjectEvents",
        ])
    }
}
